import toast from "react-hot-toast";
import i18next from "i18next";
import {BaseClient} from "../../Api/HttpClient";
import {transformObjectToGetRequestParams} from "../../Utils/HttpHelper";
import i18n from "../../i18n";

export const createApplicationSlice = (set, get) => ({
    applications: [],
    applicationsMetaData: {},
    applicationDetail: [],
    applicationDetailNotFound: false,
    getAllApplicationsFromFreelancers: async (params = {}) => {
        await BaseClient().get('/applications?' + transformObjectToGetRequestParams(params))
            .then(response => {
                if (response.status === 200) {
                    set({applications: response.data?.data})
                    set({applicationsMetaData: response.data?.meta})
                } else {
                    toast.error(response.data);
                }
            })
    },
    getApplicationDetail: async (id) => {
        set({applicationDetailNotFound: false, applicationDetail: []});
        try {
            const response = await BaseClient().get(`/applications/${id}`);
            if (response.status === 200) {
                set({applicationDetail: response.data});
            }
        } catch (error) {
            if (error?.response?.status === 404) {
                set({applicationDetailNotFound: true});
                return;
            }
            toast.error(i18next.t('errors.generic'), {id: 'application-detail-error'});
        }
    },
    submitShiftApplication: async (userId, shiftId, remark = null, appliedAsStatuut = null) => {
        try {
            const body = { freelancer_id: userId, remark };
            if (appliedAsStatuut) body.applied_as_statuut = appliedAsStatuut;
            const response = await BaseClient().post(`/shifts/${shiftId}/apply`, body);
            const applications = [...get().applications];
            const index = applications.findIndex(application => application?.shift?.id === shiftId);
            if (index !== -1) {
                applications[index] = response.data;
                set({ applications });
            }
            return response.data;
        } catch (error) {
            const data = error?.response?.data;
            if (data?.missing_docs) {
                toast.error(i18next.t('shifts.missing_docs_error'));
            } else if (data?.matching_statuten) {
                toast.error(i18next.t('shifts.choose_statuut_error'));
            } else if (data?.message) {
                toast.error(data.message);
            } else {
                toast.error(i18next.t('general.errors.generic_retry'));
            }
            return false;
        }
    },
    updateApplication: async (id, data) => {
        try {
            const response = await BaseClient().patch(`/applications/${id}`, data);
            const applications = [...get().applications];
            const index = applications.findIndex(application => application?.id === id);
            if (index !== -1) applications[index] = response.data;
            set({applications});
            set({applicationDetail: response.data});
            return response.data;
        } catch (error) {
            const code = error?.response?.data?.code;
            const key = code ? `applications_module.errors.${code}` : null;
            const fallback = i18next.t('general.errors.generic_retry');
            toast.error(key ? i18next.t(key, fallback) : fallback);
            return false;
        }
    },
    withdrawApplication: async (id) => {
        try {
            const response = await BaseClient().post(`/applications/${id}/withdraw`);
            if (response.status === 200) {
                toast.success(i18next.t('applications_module.toast_withdraw_success'));
                const applications = get().applications.filter(application => application?.id !== id);
                set({applications});
                return true;
            }
            return false;
        } catch (error) {
            if (error?.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(i18next.t('applications_module.toast_withdraw_error'));
            }
            return false;
        }
    },
    setApplicationAsReserved: async (applicationId, shiftId) => {
        try {
            const response = await BaseClient().post(`/applications/${applicationId}/set-reserved`);
            if (response.status === 200) {
                toast.success(i18next.t('applications_module.toast_reserve_success'));
                return { success: true, shiftId };
            }
            return { success: false };
        } catch (error) {
            if (error?.response?.status === 400 && error?.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                const code = error?.response?.data?.code;
                const key = code ? `errors.${code}` : 'errors.application_reserve_failed';
                toast.error(i18n.t(key, { defaultValue: i18n.t('errors.application_reserve_failed') }));
            }
            return { success: false };
        }
    }
})